import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-769c3bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "person-icon",
    src: _imports_0
  })
], -1))

import { computed } from 'vue';
import { useUserStore } from '@/gp/UserStore'
import CompactItem from '@/util/CompactItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserItem',
  props: {
    userId: {},
    small: { type: Boolean },
    noHover: { type: Boolean },
    selectMode: { type: Boolean }
  },
  emits: [
  'click'
],
  setup(__props: any, { emit }) {

const props = __props;





const userStore = useUserStore()

const userRef = computed(() => userStore.getAsyncUser(props.userId)?.data) // should be loaded by parent component

function onClick() {
  emit('click')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CompactItem, {
    class: "user-item",
    "no-hover": _ctx.noHover,
    "select-mode": props.selectMode,
    pageUrl: userRef.value?.pageUrl,
    onClick: onClick
  }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(userRef.value?.displayName), 1)
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode("User")
    ]),
    _: 1
  }, 8, ["no-hover", "select-mode", "pageUrl"]))
}
}

})